import Barcode from "react-barcode";
import { BarcodeBlockProps } from "./type";

interface Props {
  blockProps: BarcodeBlockProps;
  scaleFactor?: number;
}

export const BarcodeBlock: React.FC<Props> = (props) => {
  const { blockProps, scaleFactor = 1 } = props;
  const { value, fontSize } = blockProps;
  return value?.length > 0 ? (
    <Barcode
      margin={0}
      textMargin={0}
      value={value}
      height={fontSize * 2 * scaleFactor}
      width={fontSize * 0.075 * scaleFactor}
      fontSize={fontSize * scaleFactor}
      marginBottom={5}
      background="transparent"
    />
  ) : (
    ""
  );
};
